(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gopshop-category-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gop-category-grid')) {
    customElements.define('gop-category-grid', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }
      init() {
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.hover = matchMedia('(hover: hover) and (pointer: fine)');
        this.animations = new Set();
        this.timers = new Map();
        this.cards = Array.from(this.querySelectorAll('[data-gpc-card]'));
        const setDetail = (card, state) => {
          card.classList.toggle('is-detail', state);
          const button = card.querySelector('[data-gpc-toggle]');
          if (button) {
            button.setAttribute('aria-pressed', String(state));
            button.querySelector('[data-gpc-label]').textContent = state ? this.dataset.backLabel : this.dataset.detailLabel;
          }
        };
        const cancelPreview = card => {
          clearTimeout(this.timers.get(card));
          this.timers.delete(card);
          if (!card.dataset.gpcPinned) setDetail(card, false);
        };
        const preview = card => {
          if (this.dataset.imageMode !== 'preview' || this.hover.matches || this.motion.matches || !card.dataset.gpcVisible || !card.dataset.gpcReady || card.dataset.gpcPreviewed || card.dataset.gpcPinned || window.Shopify?.designMode) return;
          card.dataset.gpcPreviewed = 'true';
          setDetail(card, true);
          this.timers.set(card, setTimeout(() => { cancelPreview(card); }, 1800));
        };
        this.cards.forEach(card => {
          const image = card.querySelector('.gpc__image--detail');
          const button = card.querySelector('[data-gpc-toggle]');
          if (!image || !button) return;
          const ready = () => { if (image.naturalWidth > 0) { card.dataset.gpcReady = 'true'; button.hidden = false; preview(card); } };
          if (image.complete) ready();
          image.addEventListener('load', ready, { signal });
          image.addEventListener('error', () => { button.hidden = true; delete card.dataset.gpcReady; setDetail(card, false); }, { signal });
          button.addEventListener('click', () => {
            const next = button.getAttribute('aria-pressed') !== 'true';
            clearTimeout(this.timers.get(card));
            this.timers.delete(card);
            if (next) card.dataset.gpcPinned = 'true'; else delete card.dataset.gpcPinned;
            setDetail(card, next);
          }, { signal });
          card.addEventListener('pointerenter', () => {
            if (this.hover.matches && !this.motion.matches && card.dataset.gpcReady) setDetail(card, true);
          }, { signal });
          card.addEventListener('pointerleave', () => { if (!card.dataset.gpcPinned) setDetail(card, false); }, { signal });
          card.addEventListener('keydown', event => {
            if (event.key === 'Escape') { delete card.dataset.gpcPinned; cancelPreview(card); setDetail(card, false); }
          }, { signal });
        });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
            const card = entry.target;
            if (!entry.isIntersecting) { delete card.dataset.gpcVisible; cancelPreview(card); return; }
            card.dataset.gpcVisible = 'true';
            preview(card);
            if (!card.dataset.gpcSeen) {
              card.dataset.gpcSeen = 'true';
              if (this.dataset.reveal === 'true' && !this.motion.matches && !window.Shopify?.designMode && card.animate) {
                const animation = card.animate([{ transform:'translateY(14px)' },{ transform:'translateY(0)' }], { duration:480, easing:'cubic-bezier(.2,.65,.3,1)' });
                this.animations.add(animation);
                animation.onfinish = () => this.animations.delete(animation);
              }
            }
          }), { threshold:0.15 });
          this.cards.forEach(card => this.observer.observe(card));
        }
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) {
            this.animations.forEach(animation => animation.cancel());
            this.animations.clear();
            this.cards.forEach(cancelPreview);
          }
        }, { signal });
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.cards.forEach(cancelPreview); }, { signal });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.controller?.abort();
        this.timers?.forEach(timer => clearTimeout(timer));
        this.animations?.forEach(animation => animation.cancel());
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => {
        if (typeof disclosure.close === 'function') disclosure.close();
      });
    }

    closeSearchModal() {
      /* GOPSHOP: details-modal.js wird per defer geladen. Ist es (noch) nicht da oder schlägt das Laden fehl,
         ist <details-modal> nicht „upgegradet“ und hat kein close() → nicht bei jedem Scroll einen Fehler werfen. */
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
